import { Col, Row, Form, Input, Select, Space, Divider, InputNumber } from 'antd';
import {
    StarOutlined,
    PictureOutlined,
    ThunderboltOutlined,
    EditOutlined,
    EyeOutlined
} from '@ant-design/icons';

export const DatosBasicos = ({
    detalleDatos,
    tiposPrincipal,
    preevoluciones
}) => {
    return (
        <>
            <Divider orientation="left">
                <Space>
                    <StarOutlined style={{ color: '#1890ff' }} />
                    <span>Datos Básicos</span>
                </Space>
            </Divider>

            <Row gutter={[24, 16]}>
                <Col xs={24} md={12}>
                    <Form.Item
                        label={
                            <Space>
                                <PictureOutlined />
                                <span>Nombre Pokémon</span>
                            </Space>
                        }
                        name='poke_nombre'
                        rules={[{ required: true, message: 'El nombre es obligatorio' }]}
                    >
                        <Input
                            prefix={<PictureOutlined style={{ color: '#1890ff' }} />}
                            placeholder="Ingrese el nombre del Pokémon"
                            style={{ borderRadius: '8px' }}
                        />
                    </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                    <Form.Item
                        label={
                            <Space>
                                <PictureOutlined />
                                <span>Nombre Sprite</span>
                            </Space>
                        }
                        name='poke_nombre_sprite'
                    >
                        <Input
                            prefix={<PictureOutlined style={{ color: '#1890ff' }} />}
                            placeholder="Nombre del archivo sprite (ej: pikachu.png)"
                            style={{ borderRadius: '8px' }}
                        />
                    </Form.Item>
                </Col>
                <Col xs={24} md={12}>
                    <Form.Item
                        label={
                            <Space>
                                <StarOutlined />
                                <span>Número Pokédex</span>
                            </Space>
                        }
                        name='poke_numero_pokedex'
                        rules={[{ required: true, message: 'El número es obligatorio' }]}
                    >
                        <InputNumber
                            placeholder="Número en la Pokédex"
                            style={{ borderRadius: '8px', width: '100%' }}
                            min={1}
                        />
                    </Form.Item>
                </Col>

                <Col xs={24} md={12}>
                    <Form.Item
                        label={
                            <Space>
                                <StarOutlined />
                                <span>Código Pokémon</span>
                            </Space>
                        }
                        name='poke_codigo'
                        rules={[{ required: true, message: 'El código es obligatorio' }]}
                    >
                        <Input
                            prefix={<StarOutlined style={{ color: '#1890ff' }} />}
                            placeholder="Código del Pokémon (ej: BBS)"
                            style={{ borderRadius: '8px' }}
                        />
                    </Form.Item>
                </Col>

                <Col xs={24} md={8}>
                    <Form.Item
                        label={
                            <Space>
                                <ThunderboltOutlined />
                                <span>Tipo Principal</span>
                            </Space>
                        }
                        name='tipo_principal'
                        rules={[{ required: true, message: 'El tipo principal es obligatorio' }]}
                    >
                        <Select
                            placeholder="Seleccione tipo principal"
                            options={tiposPrincipal.data ?? []}
                            style={{ borderRadius: '8px' }}
                            showSearch
                            filterOption={(input, option) =>
                                (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                            }
                        />
                    </Form.Item>
                </Col>

                <Col xs={24} md={8}>
                    <Form.Item
                        label={
                            <Space>
                                <EditOutlined />
                                <span>Tipo Secundario</span>
                            </Space>
                        }
                        name='tipo_secundario'
                    >
                        <Select
                            placeholder="Tipo secundario (opcional)"
                            options={tiposPrincipal.data ?? []}
                            style={{ borderRadius: '8px' }}
                            allowClear
                            showSearch
                            filterOption={(input, option) =>
                                (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                            }
                        />
                    </Form.Item>
                </Col>

                <Col xs={24} md={8}>
                    <Form.Item
                        label={
                            <Space>
                                <EyeOutlined />
                                <span>Preevolución</span>
                            </Space>
                        }
                        name='preevolucion_id'
                    >
                        <Select
                            placeholder="Preevolución (opcional)"
                            options={preevoluciones.data ?? []}
                            style={{ borderRadius: '8px' }}
                            allowClear
                            showSearch
                            filterOption={(input, option) =>
                                (option?.label ?? "").toLowerCase().includes(input.toLowerCase())
                            }
                        />
                    </Form.Item>
                </Col>
            </Row>
        </>
    );
};
